import { Box, darkColors, Flex, lightColors, Text, useColorModeValue as mode, VStack } from '@chaine/keychaine';
import moment from 'moment';
import React from 'react';
import { Popup } from 'react-map-gl';
export const dateTimeAgo = (dateTime) => moment(new Date(dateTime)).fromNow();
export const formatDateTime = (dateTime, format = 'MM/DD/YY') => {
    return moment(dateTime).format(format);
};
export const getMotionActivity = (motionActivity) => {
    if (!motionActivity || motionActivity === 'unknown')
        return null;
    const formattedMotionActivity = motionActivity.replace(/_/g, ' ');
    const motionEmoji = {
        in_vehicle: '🚚',
        on_bicycle: '🚴',
        on_foot: '👟',
        running: '🏃',
        still: '🏡',
        walking: '👟'
    };
    return {
        activity: formattedMotionActivity.charAt(0).toUpperCase() + formattedMotionActivity.slice(1),
        emoji: motionEmoji[motionActivity]
    };
};
const LabelRow = (props) => {
    const { label, value } = props;
    const primaryTextColor = mode(lightColors.text.primary, darkColors.text.primary);
    const secondaryTextColor = mode(lightColors.text.secondary, darkColors.text.secondary);
    return (React.createElement(Flex, null,
        React.createElement(Text, { fontSize: "xs", w: 16, color: secondaryTextColor }, label),
        React.createElement(Text, { flex: 1, fontSize: "xs", color: primaryTextColor }, value)));
};
const MobileAppLocationMarkerPopup = (props) => {
    const { location, locationSourceMetadata } = props;
    const coordinates = location?.coordinates;
    const motionActivity = location?.locationInfo?.activity?.type
        ? getMotionActivity(location?.locationInfo?.activity?.type)
        : null;
    return (React.createElement(Popup, { offset: 10, latitude: coordinates?.latitude ?? 0, longitude: coordinates?.longitude ?? 0, closeButton: false },
        React.createElement(Box, { p: 4, borderRadius: "11px", borderWidth: "1px", bg: mode('white', 'black') },
            React.createElement(VStack, { spacing: 2, alignItems: 'flex-start' },
                React.createElement(Box, null,
                    React.createElement(LabelRow, { label: "Motion: ", value: motionActivity?.activity ? motionActivity.emoji + ' ' + motionActivity.activity : 'Unknown' }),
                    location?.timestamp ? (React.createElement(React.Fragment, null,
                        React.createElement(LabelRow, { label: "Time: ", value: `${formatDateTime(location?.timestamp, 'M/DD/YY h:m A')}` }),
                        React.createElement(LabelRow, { label: "    ", value: `${dateTimeAgo(location?.timestamp)}` }))) : null),
                React.createElement(LabelRow, { label: "Carrier: ", value: locationSourceMetadata?.user.name || '' })))));
};
MobileAppLocationMarkerPopup.displayName = 'MobileAppLocationMarkerPopup';
export { MobileAppLocationMarkerPopup };
